import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import Calendar from 'moedim';

const D1 = ({history}) => {

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [reason, setReason] = useState("");
  const [value, setValue] = useState(new Date());

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTime(""); // Clear selected time when a new date is selected
    setName("");
    setSurname("");
    setReason("");
  };

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };

  const handleAppointmentSubmit = () => {
    // You can handle appointment submission here, e.g., send the data to a backend API
    console.log("Selected Date:", selectedDate);
    console.log("Selected Time:", selectedTime);
    console.log("Name:", name);
    console.log("Surname:", surname);
    console.log("Reason for Appointment:", reason);
  };

  console.log(value)
  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


    <br/>
  <br/>
  <br/>
  <br/>
  <div className="app container p-5">
      <h1 className="text-center mb-2">ระบบนัดหมายสำหรับปรึกษาแพทย์ทางไกล</h1>
      <br/>
      <br/>
      <br/>
      <br/>
      <p>
          1. การขอคำปรึกษาแพทย์ผ่านระบบออนไลน์ ให้การให้คำปรึกษาโดยแพทย์ผู้เชี่ยวชาญด้านโรคหัวใจ<br/>
          2. เนื่องจากแพทย์โรคหัวใจมีทั้งคนไข้เก่า และคนไข้ใหม่อยู่เป็นจำนวนมาก ดังนั้นการนัดหมายขอคำปรึกษาแพทย์ผ่านระบบออนไลน์จะทำได้จำกัด และมีบางช่วงเวลาเท่านั้น<br/>
          3. ผู้รับบริการขอคำปรึกษาแพทย์ผ่านระบบออนไลน์ต้องเสียค่าเข้าพบแพทย์ 200 บาท และค่าธรรมเนียมอีก 40 บาท<br/>
          4. สำหรับผู้ที่ไม่เคยมีบัตรโรงพยาบาล ควรทำบัตรโรงพยาบาลก่อนนัดหมาย
      </p>
       </div>
       <div>
        <Calendar className="Calendar" value={value} onChange={(d) => setValue(d)}  />
        {value && (
          <div>
            <p className="Datepicker">
              Selected Date: {value.toLocaleDateString(undefined, { weekday: 'long' })}
              {value.getDay() === 5 && (
                <div>
                  <h2>Doctor is available. Please select a time:</h2>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("13:00-13:30")}
                  >
                    13:00-13:30
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("14:00-14:30")}
                  >
                    14:00-14:30
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("14:45-15:15")}
                  >
                    14:45-15:15
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("16:30-17:00")}
                  >
                    16:30-17:00
                  </button>
                </div>
              )}
            </p>
            {selectedTime && (
              <div>
                <h2>Appointment Information</h2>
                <input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Surname"
                  value={surname}
                  onChange={(e) => setSurname(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Reason for Appointment"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
                <button
                  className="btn-solid-lg page-scroll mx-3 my-4"
                  type="button"
                  onClick={handleAppointmentSubmit}
                >
                  Submit Appointment
                </button>
              </div>
            )}
          </div>
        )}
      </div>

       
       

      
    </>
  );
};

export default withRouter(D1);